// import Emitter from '../../emitter';
/**
 * @desc: 上传服务
 */
import driverManger from '../../driverManger';
export const firmwareUploader = {
    id: 'firmware.uploader',
    getDriver(name) {
        let uploader = driverManger.getFirmwareDriver(name);
        return (data, logH, progressH, finishH, errH) => {
            try {
                uploader(window.currentPort, data, progressH, (err, data) => {
                    if (err)
                        errH(err);
                    else
                        finishH();
                });
            }
            catch (ex) {
                console.error(ex);
                errH('' + ex);
            }
        };
    }
};
export const codeUploader = {
    id: 'code.uploader',
    getDriver(name) {
        let uploader = driverManger.getUploadDriver(name);
        return (data, logH, progressH, finishH, errH) => {
            try {
                uploader(window.currentPort, data, progressH, (err) => {
                    if (err)
                        errH(err);
                    else
                        finishH();
                });
            }
            catch (ex) {
                console.error(ex);
                errH('' + ex);
            }
        };
    }
};
